import request from '../request';

const sanitizeParams = (params = {}) => {
  const result = { ...params };
  if (Object.prototype.hasOwnProperty.call(result, 'search')) {
    const searchValue =
      result.search === undefined || result.search === null
        ? ''
        : String(result.search).trim();
    if (!searchValue) {
      delete result.search;
    } else {
      result.search = searchValue;
    }
  }
  return result;
};

const paymentService = {
  getAll: (params) =>
    request.get('rest/payments', { params: sanitizeParams(params) }),
  getById: (id) => request.get(`rest/shop-payments/${id}`),
};

export default paymentService;
